import * as React from "react"

const List = ({ className, children }) => {
  return <ul className={`${className ? className : ""}`}>{children}</ul>
}

export default List
